import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/VideosPage.head';
import { VideosPage } from '@pages/VideosPage';

export const Route = createFileRoute('/videos')({
  component: VideosPage,
  head: () => head,
});
